import {IDocumentUploadScan} from 'store/slices/documents-uploading-slice';

import {SCAN_UPLOAD_UID} from './button-upload-scan-files-constants';

export const updateFileInScanFilesList = (
    scans: IDocumentUploadScan[],
    uploadId: string,
    data: Partial<IDocumentUploadScan>,
) => scans.map(uploadedFile => {
    if (uploadedFile[SCAN_UPLOAD_UID] === uploadId) {
        return {
            ...uploadedFile,
            ...data,
        };
    }
    return uploadedFile;
});
